<template>
  <ul>
    <router-link
        tag="li"
        to="/lk/tutor-selection"
        style="margin-bottom: 1px;"
    >
      <a href="/lk/tutor-selection">
        <icon-attestation fill="#fff"  /> Отбор в тренеры
      </a>
    </router-link>
  </ul>
</template>

<script>


import mspForsageOperatorMixin from "@/mixins/mspForsageOperatorMixin";
import roleRoutersMixin from "@/mixins/roleRoutersMixin";
import IconAttestation from "@/components/icons/IconAttestation.vue";

export default {
  name: "ProfileMenuSelection",
  components: {IconAttestation},
  mixins: [mspForsageOperatorMixin, roleRoutersMixin]
}
</script>

<style scoped>

</style>